/**
 * Where a contact opens: Messages' Contacts view, with that person's card.
 *
 * Keyed by the person (or service provider) id, not by the contact-list entry:
 * search knows people rather than entries, so it can link to anyone on the
 * vessel — including someone the caller has never shared a chat with and who is
 * therefore not on their list — and the link survives the contact being removed
 * and added again.
 */

export const CONTACTS_PATH = '/inbox/contacts';

export const contactHref = (personId: string): string => `${CONTACTS_PATH}/${personId}`;
